(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row-play/assets/javascripts/ball-row-play-eurojackpot.js') >= 0) return;  svs.modules.push('/components/tur/ball-row-play/assets/javascripts/ball-row-play-eurojackpot.js'); 'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
svs.tur.ball.row.play = svs.tur.ball.row.play || {};
class Eurojackpot extends svs.tur.ball.row.play.Default {
  constructor() {
    let {
      numbers = 5,
      extraNumbers = 2,
      isSystem = false,
      size = 200,
      isValid,
      isActive,
      isEmpty
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const _numbers = isSystem ? 0 : numbers,
      _extraNumbers = isSystem ? 0 : extraNumbers;
    const row = new svs.tur.ball.row.Eurojackpot({
      numbers: _numbers,
      extraNumbers: _extraNumbers,
      size
    });
    super({
      row,
      _numbers,
      _extraNumbers,
      isSystem,
      size,
      isValid,
      isActive,
      isEmpty
    });
  }
  classNames() {
    return ['ball-row-play-eurojackpot'];
  }
}
svs.tur.ball.row.play.Eurojackpot = Eurojackpot;
 })(window);